import { Box, IconButton, Typography } from "@mui/material";
import ContractorCard from "../../permitComponents/ContractorCard";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const RenderCustomerContractors = ({ cardPage, setCardPage, table }) => {
  const handleNavigate = (direction) => {
    let newPage;
    if (direction === "forward") {
      newPage = cardPage + 1;
    } else if (direction === "back") {
      newPage = cardPage - 1;
    }

    setCardPage(newPage);
  };

  return (
    <>
      {table?.data.length > 0 ? (
        <>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              gap: 1,
            }}
            my={1}
          >
            <IconButton
              onClick={() => handleNavigate("back")}
              sx={{
                visibility: cardPage === 1 ? "hidden" : "visible",
              }}
            >
              <ArrowBackIosNewIcon sx={{ fontSize: "20px" }} />
            </IconButton>

            <Typography align="center" variant="h5">
              {table?.data.length === 0
                ? "0/0"
                : cardPage + "/" + table?.data.length}
            </Typography>
            <IconButton
              onClick={() => handleNavigate("forward")}
              sx={{
                visibility:
                  table?.data.length === 0 || cardPage === table?.data.length
                    ? "hidden"
                    : "visible",
              }}
            >
              <ArrowForwardIosIcon sx={{ fontSize: "20px" }} />
            </IconButton>
          </Box>
          <Box mb={2}>
            <ContractorCard
              data={table?.data?.[cardPage - 1]}
              // mb={0}
              colorIndex={cardPage}
              empty={table?.data.length === 0}
              showLicenseInput={false}
              contractorSite={false}
              handleEditContractor={() => {}}
              addNewActive={() => {}}
              currentContractor={table?.data[cardPage - 1]}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            gap: 1,
          }}
          mb={2}
        >
          <Typography variant="body2" fontWeight="bold" pt={2}>
            No Contractors Added Yet
          </Typography>
        </Box>
      )}
    </>
  );
};

export default RenderCustomerContractors;
